require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-08-20-quote-of-the-day.json") })
        }
      }, "path---articles-2005-08-20-quote-of-the-day");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-08-20-quote-of-the-day!./.cache/json/articles-2005-08-20-quote-of-the-day.json
// module id = 421
// module chunks = 231608221292675